import { useEffect, useRef } from 'react';

/**
 * Startet sofort einen Fetch beim Mount und wiederholt ihn automatisch.
 * Sicher gegen stale closures – fnRef hält immer die neueste fetchFn.
 * Cleanup (clearInterval) passiert automatisch beim Unmount.
 *
 * @param {() => void} fetchFn    - Die Fetch-Funktion
 * @param {number}     intervalMs - Refresh-Intervall in ms (default: 60 Sekunden)
 *
 * @example
 * useAutoRefresh(loadPrices, 60_000);
 */
export function useAutoRefresh(fetchFn, intervalMs = 60_000) {
  const fnRef = useRef(fetchFn);
  fnRef.current = fetchFn; // immer neueste Version – kein stale closure

  useEffect(() => {
    fnRef.current(); // sofort beim Mount

    const id = setInterval(() => {
      fnRef.current();
    }, intervalMs);

    return () => clearInterval(id); // sauber beim Unmount
  }, [intervalMs]); // nur neu starten wenn Intervall sich ändert
}
